<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>

<div class="image">
  <img src="../../../assets/img/lorry.svg" />
</div>

<form class="admin-forms" [formGroup]="notifyform">
  <div class="accordion-class">
    <h5>Notify Near by Drivers</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Work Order No:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="workorder_id"
              required
            >
              <mat-option
                *ngFor="let item of workorderArray"
                [value]="item._id"
                (click)="selectChangeHandler(item)"
              >
                {{ item.workorder_id }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">Actual Price Per Ton:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input matInput formControlName="price_per_ton" readonly />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Work Order Date:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field class="flex-gt-sm example-full-width">
            <input matInput formControlName="work_order_date" readonly />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <label for="html">Total Tons:</label>
        </div>
        <div class="col-md-2 total_tons">
          <mat-form-field class="flex-gt-sm">
            <input matInput formControlName="total_tons" readonly />
          </mat-form-field>
          <label for="html" class="mt-4">Tons</label>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Remaining Tons:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input matInput formControlName="remaining_tons" readonly />
          </mat-form-field>
        </div>
      </div>
      <hr />
      <h5 class="c2">Trip Details</h5>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html"> Trip Booking Date:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker1></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker1"
              placeholder="DD-MM-YYYY"
              [min]="minDate"
              formControlName="trip_booking_date"
              (click)="picker1.open()"
              required
            />
            <mat-error>Please Enter Trip Booking Date </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <label for="html">Truck Category</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="truck_category"
              required
            >
              <mat-option
                *ngFor="let item of truckTypeList"
                [value]="item.truck_category_id"
              >
                {{ item.truckCategory[0]?.truck_category_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html">Price Per Ton:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="price_ton"
              required
            />
            <mat-error>Please enter price per ton in numbers</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">Work order quantity:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appThreeDigitDecimalNumber
              formControlName="work_order_quantity"
              (focusout)="remainingQnty($event)"
              required
            />
            <mat-error>Please enter work order quantity in numbers</mat-error>
          </mat-form-field>
        </div>
      </div>
      <br />
      <hr />
      <h5 class="c3">Notification Settings (From Pickup)</h5>
      <br />
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <label for="html"> Notification Radius:</label>
        </div>
        <div class="col-md-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <input
              matInput
              appTwoDigitDecimaNumber
              formControlName="notification_radius"
              required
            />
            <mat-error>Please enter notification radius in numbers</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <label for="html">KMS</label>
        </div>
      </div>
      <div class="row">
        <div class="ex0 buttons">
          <button type="submit" class="button buttonBlue" (click)="notify()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
